import { render, staticRenderFns } from "./UiSwitch.vue?vue&type=template&id=758e5ad9&"
import script from "./UiSwitch.vue?vue&type=script&lang=js&"
export * from "./UiSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports